import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Layout from "../layouts/index";
import Grid from "@mui/material/Grid2";
import { Typography, Button } from "@mui/material";
import carouselData from "../data/homeCarousel.json";
import BackgroundImageBottom from "../assets/images/shape_crescent-bottom.png";
import RediflyTabSection from "../components/pagesComponents/RediflyTabSection";
import AircraftBackground from "../assets/images/main-homebackground-aircraft-image.png";
import TalktoUs from "../components/pagesComponents/TalktoUs";
import DiscoverSection from "../components/pagesComponents/DiscoverSection";
import ProductFeatures from "../components/pagesComponents/ProductFeatures";
import AirOperators from "../components/pagesComponents/AirOperators";
import CustomerReviews from "../components/pagesComponents/CustomerReviews";
import ProductBenefits from "../components/pagesComponents/ProductBenefits";
import LogoCarousel from "../components/pagesComponents/LogoCarousel";
import EtlFeaturesData from "../data/etlFeatures.json";
import EtlBenefitsData from "../data/etlBenefits.json";
import EtlCustomerData from "../data/etlCustomerReviews.json";
import WebinarSection from "../components/pagesComponents/WebinarSection";
import { styled } from "@mui/material/styles";
import $ from "jquery";
import ETLIntro from "../assets/images/etl-page/elt_intro.png";
import WhyEtech from "../components/pagesComponents/WhyEtech";
import ClientReview from "../components/pagesComponents/ClientReview";
import EtlModuleTab from "../components/pagesComponents/EtlModuleTabs";
import HowItWorks from "../components/pagesComponents/HowItWorks";
import IntegrationPartners from "../components/pagesComponents/IntegrationPartners";
import EtlPros from "../components/pagesComponents/EtlPros";
import KeyBenefits from "../components/pagesComponents/KeyBenefits";

const PREFIX = "ETLPage";
const classes = {
  indexCarousrlBlockContainer: `${PREFIX}-indexCarousrlBlockContainer`,
  backgroundDesign1: `${PREFIX}-backgroundDesign1`,
  fingertipTitleGrid: `${PREFIX}-fingertipTitleGrid`,
  fingertipTitle: `${PREFIX}-fingertipTitle`,
  fingertipTitle2Grid: `${PREFIX}-fingertipTitle2Grid`,
  homePageTitle: `${PREFIX}-homePageTitle`,
  homePageTitledesc: `${PREFIX}-homePageTitledesc`,
  sliderDiv: `${PREFIX}-sliderDiv`,
  fingertipTitle2: `${PREFIX}-fingertipTitle2`,
  clientsHeadingGrid: `${PREFIX}-clientsHeadingGrid`,
  clientsHeading: `${PREFIX}-clientsHeading`,
  buttonStyles: `${PREFIX}-buttonStyles`,
  homeButtonItem: `${PREFIX}-homeButtonItem`,
  exploreButtonStyle: `${PREFIX}-exploreButtonStyle`,
  demoButtonGrid: `${PREFIX}-demoButtonGrid`,
  demoButtonStyle: `${PREFIX}-demoButtonStyle`,
  productTabLabel: `${PREFIX}-productTabLabel`,
  productTabSelected: `${PREFIX}-productTabSelected`,
  backgroundDesign2: `${PREFIX}-backgroundDesign2`,
  exploreProductLink: `${PREFIX}-exploreProductLink`,
  tabContainerBlock: `${PREFIX}-tabContainerBlock`,
  buttonContainer: `${PREFIX}-buttonContainer`,
  productTabsContainer: `${PREFIX}-productTabsContainer`,
  productTabsDesc: `${PREFIX}-productTabsDesc`,
  tabContainerTabs: `${PREFIX}-tabContainerTabs`,
  blueContent: `${PREFIX}-blueContent`,
  exploreAnchorLink: `${PREFIX}-exploreAnchorLink`,
  fingertipTitleSubHeading: `${PREFIX}-fingertipTitleSubHeading`,
  videoMainGrid: `${PREFIX}-videoMainGrid`,
  clientsHeading: `${PREFIX}-clientsHeading`,
  lineStyle: `${PREFIX}-lineStyle`,
  takeControl: `${PREFIX}-takeControl`,

};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.videoMainGrid}`]: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    img: {
      width: "100%",
      height: "auto",
      [theme.breakpoints.up("sm")]: {
        width: "auto",
        height: "100%",
      },
    },
  },
  [`& .${classes.fingertipTitle}`]: {
    position: "relative",
    fontFamily: "AvenirLTStd-Roman",
    left: "0.7em",
    fontSize: 35,
    fontWeight: 100,
    padding: "40px 0 0 15px",
    [theme.breakpoints.down("sm")]: {
      top: 0,
      width: "100%",
      margin: 0,
      left: 0,
      textAlign: "center",
      fontSize: 22,
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: 30,
    },
    [theme.breakpoints.between("lg", "xl")]: {
      paddingTop: "7em",
      fontSize: 35,
    },
  },
  [`& .${classes.fingertipTitleSubHeading}`]: {
    position: "relative",
    fontFamily: "AvenirLTStd-Book",
    left: "0.7em",
    color: "grey",
    fontSize: 15,
    fontWeight: 10,
    paddingTop: "10px",
    paddingLeft: "30px",
    [theme.breakpoints.down("sm")]: {
      top: 0,
      width: "100%",
      margin: 0,
      left: 0,
      paddingLeft: "0px",
      textAlign: "center",
    },
    [theme.breakpoints.between("sm", "md")]: {},
    [theme.breakpoints.between("lg", "xl")]: {},
  },
  [`& .${classes.fingertipTitle2Grid}`]: {
    display: "flex",
    justifyContent: "left",
    backgroundColor: "#fefbfb",
    paddingBottom: "2em",
  },
  [`& .${classes.fingertipTitle2}`]: {
    position: "relative",
    fontFamily: "AvenirLTStd-Roman",
    left: "0.7em",
    fontSize: 35,
    fontWeight: 100,
    paddingLeft: "15px",
    [theme.breakpoints.down("sm")]: {
      top: 0,
      width: "100%",
      margin: 0,
      left: 0,
      textAlign: "left",
      fontSize: 22,
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: 30,
    },
    [theme.breakpoints.between("md", "lg")]: {
      fontSize: 35,
    },
  },
  [`& .${classes.homePageTitle}`]: {
    textAlign: "left",
    letterSpacing: "0.66px",
    color: "#223140",
    padding: "3em 0.5em 0 1em",
    width: "90%",
    fontFamily: "AvenirLTStd-Roman",
    fontSize: 32,
    fontWeight: "600",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: 0,
      padding: "0.5em 0.5em 0 1em",
      textAlign: "left",
      fontSize: 25,
    },

    [theme.breakpoints.between("sm", "md")]: {
      padding: "0.5em 0.5em 0 1em",
      width: "100%",
      marginTop: "10%",
      fontSize: 30,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 30,
    },
  },
  [`& .${classes.homePageTitledesc}`]: {
    padding: "2em 1em 1em 1.75em",
    fontSize: 20,
    fontWeight: 100,
    width: "90%",
    color: "#223140",
    LineHeight: "100%",
    fontFamily: "AvenirLTStd-Book",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: "0.5em 0.5em 0 1em",
      marginTop: "1em",
      fontSize: 16,
    },
    [theme.breakpoints.between("sm", "md")]: {
      padding: "2em 1em 1em 1em",
      fontSize: 25,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 25,
    },
    [theme.breakpoints.up("md")]: {},
  },

  [`& .${classes.buttonStyles}`]: {
    borderRadius: "24px",
    textTransform: "inherit",
    width: 400,
    fontSize: 20,
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
    },
  },
  [`& .${classes.homeButtonItem}`]: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      margin: "1em 0 1em 0",
      justifyContent: "center",
      display: "flex",
    },
  },
  [`& .${classes.exploreButtonStyle}`]: {
    whiteSpace: "nowrap",
    background: "#B41E1C",
    color: "#fff",
    fontWeight: "none",
    marginLeft: "1.5em",
    fontFamily: "AvenirLTStd-Roman",
    "&:hover": {
      background: "#fff",
      color: "#B41E1C",
      boxShadow: "5px 5px 13px 5px rgba(0,0,0,0.15)",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      marginLeft: 0,
      fontSize: 15,
      display: "flex",
      justifyContent: "center",
    },
    [theme.breakpoints.between("sm", "md")]: {
      width: "100%",
      fontSize: 20,
      display: "flex",
      justifyContent: "center",
    },
    [theme.breakpoints.up("lg", "xl")]: {
      fontSize: 20,
      display: "flex",
      justifyContent: "center",
    },
  },
  [`& .${classes.demoButtonGrid}`]: {
    display: "flex",
    justifyContent: "left",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
  [`& .${classes.demoButtonStyle}`]: {
    textTransform: "inherit",
    fontFamily: " AvenirLTStd-Roman",
    width: 200,
    fontSize: 20,
    background: "#fff",
    color: "#B41E1C",
    border: "1px solid #B41E1C",
    fontWeight: "none",
    "&:hover": {
      background: "#fff",
      color: "#B41E1C",
      boxShadow: "5px 5px 13px 5px rgba(0,0,0,0.15)",
    },
    [theme.breakpoints.down("xs")]: {
      width: 150,
      margin: "1em 0 0 0em",
      fontSize: 15,
    },
    [theme.breakpoints.between("sm", "md")]: {
      width: 200,
      margin: "2em 0 0 0em",
    },
  },
  [`& .${classes.backgroundDesign1}`]: {
    paddingLeft: "2em",
  },
  [`& .${classes.buttonContainer}`]: {
    marginTop: "1em",
  },
  [`& .${classes.indexCarousrlBlockContainer}`]: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      gridTemplateColumns: "1fr 1fr",
      height: "650px",
    },
  },
  [`& .${classes.clientsHeading}`]: {
    marginBottom: "10px",
    fontFamily: "AvenirLTStd-Roman",
    fontSize: 28,
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: 28,
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: 28,
    },
    [theme.breakpoints.between("md", "lg")]: {
      fontSize: 28,
    },
  },
  [`& .${classes.lineStyle}`]: {
    position: "relative",
    paddingTop: "2rem",
    paddingBottom: "2rem",
    "&::after": {
      content: '""',
      display: "block",
      width: "50%",
      height: "1px",
      backgroundColor: "#DCDCDC",
      position: "absolute",
      bottom: 0,
      left: "50%",
      transform: "translateX(-50%)",
    },
  },
  [`& .${classes.takeControl}`]: {
    background: "#F0F8FF",
    padding: "1%",
    display: "flex",
    alignItems: "center",
    marginTop: "2%",
    justifyContent: "center",
  },
  [`& .${classes.blueContent}`]: {
    fontFamily: "AvenirLTStd-Roman",
  }

}));

const ETLPage = ({ ...props }) => {
  //  const handleChange = (event, value) => {
  //     this.setState({ value });
  //   };

  useEffect(() => {
    loadCarousel();
  }, []);
  const loadCarousel = () => {
    $(".my-flipster").slick({
      autoplay: true,
      autoplaySpeed: 10000,
      infinite: true,
      vertical: true,
      verticalSwiping: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  };

  const handleEmailClick = () => {
    const subject = encodeURIComponent("REDiFly Product Demo Request");
    const email = "sales@redifly.com";
    const mailtoLink = `mailto:${email}?subject=${subject}`;

    window.location.href = mailtoLink;
  };

  return (
    <StyledGrid container>
      <Grid size={{ xs: 12 }}>
        <Layout>
          <div>
            <Grid
              container
              className={classes.indexCarousrlBlockContainer}
              spacing={2}
            >
              <Grid
                item
                xs={12}
                sm={7}
                md={7}
                lg={7}
                className={classes.backgroundDesign1}
              >
                <Typography variant="h1" className={classes.homePageTitle}>
                  The RED<span style={{ color: "#c20d0b" }}>iFly</span>{" "}
                  e-Techlog
                </Typography>
                <Typography
                  variant="body2"
                  className={classes.homePageTitledesc}
                >
                  Digitise the current paper-based (ATL) improving fleet
                  airworthiness, enabling preventative maintenance, and
                  future-proofing aircraft performance through the analyses of
                  real-time data.
                </Typography>
                <Grid container className={classes.buttonContainer} spacing={2}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={8}
                    lg={8}
                    className={classes.homeButtonItem}
                  >
                    <Button
                      variant="contained"
                      href="https://calendly.com/redifly/discoverycall"
                      target="_blank"
                      className={[
                        classes.buttonStyles,
                        classes.exploreButtonStyle,
                      ].join(" ")}
                    >
                      Schedule a Discovery Call
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={5}
                md={5}
                lg={5}
                className={classes.videoMainGrid}
              >
                <img src={ETLIntro} alt="ETL Image" />
              </Grid>
            </Grid>

            <Grid size={{ xs: 12 }}>
              <WhyEtech />
            </Grid>
            {/* <Grid size={{ xs: 12 }}>
              <Typography variant="h6" className={classes.clientsHeading}>
                Who We Work With
              </Typography>
              <LogoCarousel />
            </Grid> */}
            <Grid size={{ xs: 12 }}>
              <ClientReview />
            </Grid>
            <div
                style={{
                  margin: "2% auto 0 auto",
                  borderRadius: "45px",
                  background: "#F0F8FF",
                  padding: "16px",
                  boxSizing: "border-box",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "70%",
                  marginBottom: "2%",
                }}
                sx={{
                  width: { xs: "80%", sm: "80%", md: "70%", lg: "60%" },
                }}
              >
                <Grid
                  className={classes.blueContainer}
                  sx={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                  size={{
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 12,
                  }}
                  // data-aos="fade-up"
                  // data-aos-duration="3000"
                >
                  <Typography
                    variant="body"
                    sx={{
                      width: "80%",
                      fontWeight: 400,
                      fontFamily: "AvenirLTStd-Book",
                      fontSize: {
                        xs: "16px",
                        sm: "20px",
                        md: "20px",
                        lg: "20px",
                      },
                      lineHeight: "180%",
                      padding: "1%",
                    }}
                  >
                    Take control of your data - We provide a modular and
                    configurable electronic tech log that provides real-time
                    visibility of airworthiness across your entire fleet.
                  </Typography>
                </Grid>
              </div>
            <Grid size={{ xs: 12 }}>
              <EtlModuleTab />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <HowItWorks />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <IntegrationPartners />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <ProductBenefits benefitsData={EtlBenefitsData} />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <EtlPros />
            </Grid>
            <Grid size={{ xs: 12 }} className={classes.lineStyle}></Grid>
            <Grid size={{ xs: 12 }}>
              <KeyBenefits />
            </Grid>
            <Grid size={{ xs: 12 }} className={classes.lineStyle}></Grid>
            <Grid size={{ xs: 12 }}>
              <AirOperators />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TalktoUs />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <WebinarSection />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <DiscoverSection />
            </Grid>
          </div>
        </Layout>
      </Grid>
    </StyledGrid>
  );
};
export default ETLPage;
